export default __webpack_public_path__ + "static/media/text-align-center-16.00f97f34.svg";